export const actions = {
  PROVIDED_EMAIL: 'PROVIDED_EMAIL',
  CREATED_BENCH_ACCOUNT: 'CREATED_BENCH_ACCOUNT',
  PROVIDED_COMPANY_DETAILS: 'PROVIDED_COMPANY_DETAILS',
  PROVIDED_CONTACT_DETAILS: 'PROVIDED_CONTACT_DETAILS',
};

export const actionData = {
  [actions.PROVIDED_EMAIL]: {
    eventName: 'Conversion: Provided Email',
  },
  [actions.CREATED_BENCH_ACCOUNT]: {
    eventName: 'Conversion: Created Account',
  },
  [actions.PROVIDED_COMPANY_DETAILS]: {
    eventName: 'Conversion: Provided Company Details',
  },
  [actions.PROVIDED_CONTACT_DETAILS]: {
    eventName: 'Conversion: Provided Contact Details',
  },
};
